import type { UsageListEntity } from '~/domain/Insurance/usageListEntity';
import type { UsageListResponseDTO } from '~/dto/Insurance/usageListDTO';
import { usageListResponseMapper } from '~/mappers/Insurance/usageListMapper';
import apiAssegurouAuto from '~/services/apiAssegurouAuto';

export async function getUsageListUseCase(): Promise<UsageListEntity> {
  try {
    const response = await apiAssegurouAuto.get<UsageListResponseDTO>(
      `/auto/getListaUtilizacao/1`
    );
    return usageListResponseMapper(response.data);
  } catch (error) {
    return { success: false, usageList: [] };
  }
}
